export default __webpack_public_path__ + "static/media/remove-icon.c04ca6a3.svg";